import { IconChevronDown, IconImportFile } from "@/assets/icons";
import { Button } from "@/components/elements/Button";
import { Menu, MenuItem, Typography } from "@mui/material";
import { FC, MouseEvent, useState } from "react";

type TLearnerImportMenuButtonProps = {
  // irohana visa から取り込むモーダルを開く。
  onSelectVisaImport: () => void;
  // ファイル (csv/xlsx/xlsm) から取り込むモーダルを開く。
  onSelectFileImport: () => void;
  // Visa 未連携の場合は visa 取り込みを選べない。
  disabledVisaImport?: boolean;
};

/**
 * 「取り込み」ボタン。押下でメニューを開き、取り込み元 (irohana visa / CSV) を選択させる。
 */
export const LearnerImportMenuButton: FC<TLearnerImportMenuButtonProps> = ({
  onSelectVisaImport,
  onSelectFileImport,
  disabledVisaImport,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleClose = () => setAnchorEl(null);

  // メニューを閉じてから対象のモーダルを開く。
  const handleSelect = (onSelect: () => void) => () => {
    handleClose();
    onSelect();
  };

  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="md"
        startIcon={<IconImportFile width={20} height={20} />}
        // メニューが開いている間は矢印を反転させ、開閉状態が分かるようにする。
        endIcon={
          <IconChevronDown
            fontSize={20}
            style={{ transform: anchorEl ? "rotate(180deg)" : "none", transition: "transform 0.2s" }}
          />
        }
        onClick={(e: MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget)}
      >
        <Typography variant="body14Semi">取り込み</Typography>
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{ sx: { minWidth: anchorEl?.offsetWidth } }}
      >
        <MenuItem disabled={disabledVisaImport} onClick={handleSelect(onSelectVisaImport)}>
          irohana visa取り込み
        </MenuItem>
        <MenuItem onClick={handleSelect(onSelectFileImport)}>CSV取り込み</MenuItem>
      </Menu>
    </>
  );
};
